import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Biome",
  "description": "Turborepo 프로젝트에서 Biome을 사용하는 방법을 알아보세요."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Biome은 JavaScript, TypeScript, JSX, JSON을 위한 빠른 포매터로 CI와 개발자 시간을 절약합니다."
  }, {
    "heading": "turborepo와-함께-biome-사용하기",
    "content": "Biome은 Turborepo와 함께 사용되는 대부분의 도구와는 달리 매우 빠른 예외적인 도구입니다. 이러한 이유로, 각 패키지에 별도의 스크립트를 만드는 대신 Root Task를 사용하는 것을 권장합니다."
  }, {
    "heading": "turborepo와-함께-biome-사용하기",
    "content": "프로젝트 루트에서 Biome을 사용하면 Biome 버전을 업그레이드하거나 설정을 변경할\n때 모든 작업에 대해 캐시 미스가 발생합니다. 이러한 상황에서 적은 설정보다 높은\n캐시 적중률의 장단점을 선호하는 경우, 가이드의 다른 권장 사항처럼 별도의\n스크립트에서 Biome을 사용할 수 있습니다."
  }, {
    "heading": "biome-초기화",
    "content": "먼저, 저장소에서 Biome 설정을 위한 설치 문서를 따르세요. 그런 다음 저장소의 루트에서 Biome을 사용할 스크립트를 만들 수 있습니다:"
  }, {
    "heading": "root-task-생성",
    "content": "실제로 Biome은 저장소의 반복 속도에 병목 현상이 될 가능성이 낮습니다. 이러한 이유로, Root Task에서 Biome을 사용하여 저장소에서 관리할 설정을 줄일 수 있습니다."
  }, {
    "heading": "root-task-생성",
    "content": "저장소에서 패키지의 작업으로 분할하는 것이 Biome이 더 빠를 것이라고 생각한다면\n그렇게 하셔도 됩니다. 사용 사례에 가장 적합한 것을 실험해 보시기 바랍니다."
  }, {
    "heading": "root-task-생성",
    "content": "Root Task를 생성하려면 스크립트를 Turborepo에 등록하세요:"
  }, {
    "heading": "root-task-생성",
    "content": "이제 turbo run format-and-lint와 turbo run format-and-lint:fix를 사용하여 이러한 스크립트를 실행할 수 있습니다."
  }],
  "headings": [{
    "id": "turborepo와-함께-biome-사용하기",
    "content": "Turborepo와 함께 Biome 사용하기"
  }, {
    "id": "biome-초기화",
    "content": "Biome 초기화"
  }, {
    "id": "root-task-생성",
    "content": "Root Task 생성"
  }]
};
import {Callout} from '#components/callout';
import {CreateTurboCallout} from './create-turbo-callout.tsx';
export const toc = [{
  depth: 2,
  url: "#turborepo와-함께-biome-사용하기",
  title: _jsx(_Fragment, {
    children: "Turborepo와 함께 Biome 사용하기"
  })
}, {
  depth: 3,
  url: "#biome-초기화",
  title: _jsx(_Fragment, {
    children: "Biome 초기화"
  })
}, {
  depth: 3,
  url: "#root-task-생성",
  title: _jsx(_Fragment, {
    children: "Root Task 생성"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://biomejs.dev/",
        children: "Biome"
      }), "은 JavaScript, TypeScript, JSX, JSON을 위한 빠른 포매터로 CI와 개발자 시간을 절약합니다."]
    }), "\n", _jsx(CreateTurboCallout, {}), "\n", _jsx(_components.h2, {
      id: "turborepo와-함께-biome-사용하기",
      children: "Turborepo와 함께 Biome 사용하기"
    }), "\n", _jsxs(_components.p, {
      children: ["Biome은 Turborepo와 함께 사용되는 대부분의 도구와는 달리 ", _jsx(_components.strong, {
        children: "매우 빠른"
      }), " 예외적인 도구입니다. 이러한 이유로, 각 패키지에 별도의 스크립트를 만드는 대신 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "Root Task"
      }), "를 사용하는 것을 권장합니다."]
    }), "\n", _jsx(Callout, {
      type: "info",
      title: "캐싱 동작",
      children: _jsx(_components.p, {
        children: "프로젝트 루트에서 Biome을 사용하면 Biome 버전을 업그레이드하거나 설정을 변경할\n때 모든 작업에 대해 캐시 미스가 발생합니다. 이러한 상황에서 적은 설정보다 높은\n캐시 적중률의 장단점을 선호하는 경우, 가이드의 다른 권장 사항처럼 별도의\n스크립트에서 Biome을 사용할 수 있습니다."
      })
    }), "\n", _jsx(_components.h3, {
      id: "biome-초기화",
      children: "Biome 초기화"
    }), "\n", _jsxs(_components.p, {
      children: ["먼저, 저장소에서 ", _jsx(_components.a, {
        href: "https://biomejs.dev/guides/getting-started/",
        children: "Biome 설정을 위한 설치 문서"
      }), "를 따르세요. 그런 다음 저장소의 루트에서 Biome을 사용할 스크립트를 만들 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"format-and-lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"biome check .\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"format-and-lint:fix\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"biome check . --write\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "root-task-생성",
      children: "Root Task 생성"
    }), "\n", _jsxs(_components.p, {
      children: ["실제로 Biome은 저장소의 반복 속도에 병목 현상이 될 가능성이 낮습니다. 이러한 이유로, ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "Root Task"
      }), "에서 Biome을 사용하여 저장소에서 관리할 설정을 줄일 수 있습니다."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsx(_components.p, {
        children: "저장소에서 패키지의 작업으로 분할하는 것이 Biome이 더 빠를 것이라고 생각한다면\n그렇게 하셔도 됩니다. 사용 사례에 가장 적합한 것을 실험해 보시기 바랍니다."
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#registering-root-tasks",
        children: "Root Task"
      }), "를 생성하려면 스크립트를 Turborepo에 등록하세요:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"//#format-and-lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"//#format-and-lint:fix\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이제 ", _jsx(_components.code, {
        children: "turbo run format-and-lint"
      }), "와 ", _jsx(_components.code, {
        children: "turbo run format-and-lint:fix"
      }), "를 사용하여 이러한 스크립트를 실행할 수 있습니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
